import {
  ADD_SURVEY_FAIL, ADD_SURVEY_REQUEST, ADD_SURVEY_SUCCESS, CHANGE_ADD_SURVEY_FORM_DATA, CLEAR_SURVEY_FORM_DATA, DELETE_SURVEY_FAIL, DELETE_SURVEY_REQUEST, DELETE_SURVEY_SUCCESS, GET_SURVEY_FAIL, GET_SURVEY_LIST_DATA_FAIL, GET_SURVEY_LIST_DATA_REQUEST, GET_SURVEY_LIST_DATA_SUCCESS, GET_SURVEY_REQUEST, GET_SURVEY_SUCCESS, LOGIN_FAIL, LOGIN_REQUEST, LOGIN_SUCCESS, GET_LANGUAGES_REQUEST,
  GET_LANGUAGES_SUCCESS,
  GET_LANGUAGES_FAIL, ADD_SURVEY_ASSIGN_TO_REQUEST,
  ADD_SURVEY_ASSIGN_TO_SUCCESS,
  ADD_SURVEY_ASSIGN_TO_FAIL,
  GET_SURVEY_ASSIGN_TO_REQUEST,
  GET_SURVEY_ASSIGN_TO_SUCCESS,
  GET_SURVEY_ASSIGN_TO_FAIL,
   GET_WEBHOOKS_REQUEST,
  GET_WEBHOOKS_SUCCESS,
  GET_WEBHOOKS_FAIL,
  UPDATE_WEBHOOK_REQUEST,
  UPDATE_WEBHOOK_SUCCESS,
  UPDATE_WEBHOOK_FAIL,
  DELETE_WEBHOOK_REQUEST,
  DELETE_WEBHOOK_SUCCESS,
  DELETE_WEBHOOK_FAIL,
  GET_WEBHOOK_EVENTS_REQUEST,
  GET_WEBHOOK_EVENTS_SUCCESS,
  GET_WEBHOOK_EVENTS_FAIL,
  CREATE_WEBHOOK_REQUEST,
  CREATE_WEBHOOK_SUCCESS,
  CREATE_WEBHOOK_FAIL,
    GET_ACTIVE_WEBHOOKS_REQUEST,
    GET_ACTIVE_WEBHOOKS_SUCCESS,
    GET_ACTIVE_WEBHOOKS_FAIL,
    GET_PRIVACY_POLICY_REQUEST,
    GET_PRIVACY_POLICY_SUCCESS,
    GET_PRIVACY_POLICY_FAIL,
    SAVE_PRIVACY_POLICY_REQUEST,
    SAVE_PRIVACY_POLICY_SUCCESS,
    SAVE_PRIVACY_POLICY_FAIL,
    GET_COOKIE_POLICY_REQUEST,
    GET_COOKIE_POLICY_SUCCESS,
    GET_COOKIE_POLICY_FAIL,
    SAVE_COOKIE_POLICY_REQUEST,
    SAVE_COOKIE_POLICY_SUCCESS,
    SAVE_COOKIE_POLICY_FAIL,
    TOGGLE_COOKIE_POLICY_REQUEST,
    TOGGLE_COOKIE_POLICY_SUCCESS,
    TOGGLE_COOKIE_POLICY_FAIL,
} from "../constant"

const initialState = {
  surveyData: [],
  languageList: [],
  totalRecords: null,
  addSurveyFormData: {},

  surveyDataLoading: false,
  surveyAssignToLoading: false,
  surveyAssignToDataAdd: null,
  surveyAssignToLoading: false,
  surveyAssignToData: [],
   webhookList: [],
  webhookLoading: false,
  webhookEvents: [],
  createWebhookLoading: false,
  webhookActiveList: [],
activeWebhookLoading: false,
  privacyPolicyLoading: false,
  privacyPolicy: null,
  cookiePolicyLoading: false,
  cookiePolicy: null,


}

const surveyReducer = (state = initialState, action) => {
  switch (action.type) {
    //Get survey
    case GET_SURVEY_REQUEST:
      return {
        ...state,
        surveyData: [],
        totalRecords: null,
        surveyDataLoading: true
      }
    case GET_SURVEY_SUCCESS:
      return {
        ...state,
        surveyData: action.payload?.data,
        totalRecords: action.payload?.totalRecords,
        surveyDataLoading: false
      }
    case GET_SURVEY_FAIL:
      return {
        ...state,
        surveyData: [],
        totalRecords: null,
        surveyDataLoading: false
      }

    //Get survey list data
    case GET_SURVEY_LIST_DATA_REQUEST:
      return {
        ...state,
      }
    case GET_SURVEY_LIST_DATA_SUCCESS:
      const listData = action.payload
      let tmpList = state?.surveyData?.map((survey) => ({ ...survey, ...listData[survey.survey_id] }))
      // console.log('tmpList', tmpList);
      return {
        ...state,
        surveyData: [...tmpList]
      }
    case GET_SURVEY_LIST_DATA_FAIL:
      return {
        ...state,
      }

    //Add survey
    case ADD_SURVEY_REQUEST:
      return {
        ...state,
      }
    case ADD_SURVEY_SUCCESS:
      return {
        ...state,
        addSurveyFormData: {},
      }
    case ADD_SURVEY_FAIL:
      return {
        ...state,
      }

    //Get survey
    case DELETE_SURVEY_REQUEST:
      return {
        ...state,
      }
    case DELETE_SURVEY_SUCCESS:
      return {
        ...state,
      }
    case DELETE_SURVEY_FAIL:
      return {
        ...state,
      }

    //Clear form data
    case CLEAR_SURVEY_FORM_DATA:
      return {
        ...state,
        addSurveyFormData: {}
      }

    //Add survay form data
    case CHANGE_ADD_SURVEY_FORM_DATA:
      return {
        ...state,
        addSurveyFormData: { ...state.addSurveyFormData, [action.payload?.key]: action.payload?.data }
      }


    case GET_LANGUAGES_REQUEST:
      return {
        ...state,
        loading: true
      };
    case GET_LANGUAGES_SUCCESS:
      return {
        ...state,
        languageList: action.payload,
        loading: false
      };
    case GET_LANGUAGES_FAIL:
      return {
        ...state,
        languageList: [],
        loading: false,
        error: "Failed to fetch languages"
      };

    // Add survey assignment
    case ADD_SURVEY_ASSIGN_TO_REQUEST:
      return {
        ...state,
        surveyAssignToLoading: true,
      };

    case ADD_SURVEY_ASSIGN_TO_SUCCESS:
      return {
        ...state,
        surveyAssignToDataAdd: action.payload,
        surveyAssignToLoading: false,
      };
    case ADD_SURVEY_ASSIGN_TO_FAIL:
      return {
        ...state,
        surveyAssignToDataAdd: null,
        surveyAssignToLoading: false,
      };

      case GET_SURVEY_ASSIGN_TO_REQUEST:
        return {
          ...state,
          surveyAssignToLoading: true,
          error: null,
        };
      
      case GET_SURVEY_ASSIGN_TO_SUCCESS:
        return {
          ...state,
          surveyAssignToLoading: false,
          surveyAssignToData: action.payload?.data || [], 
          error: null,
        };
      
      case GET_SURVEY_ASSIGN_TO_FAIL:
        return {
          ...state,
          surveyAssignToLoading: false,
          surveyAssignToData: [],
          error: action.payload,
        };
        // in reducer
       case 'GET_ELOQUA_SETTINGS_SUCCESS':
      return {
      ...state,
       eloquaSettings: action.payload, // contains eloqua_active
  };
  // Get Webhooks

case CREATE_WEBHOOK_REQUEST:
  return {
    ...state,
    createWebhookLoading: true,
  };
case CREATE_WEBHOOK_SUCCESS:
  return {
    ...state,
    createWebhookLoading: false,
  };
case CREATE_WEBHOOK_FAIL:
  return {
    ...state,
    createWebhookLoading: false,
  };


case GET_WEBHOOKS_REQUEST:
  return {
    ...state,
    webhookLoading: true,
    webhookList: [],
  };
case GET_WEBHOOKS_SUCCESS:
  return {
    ...state,
    webhookLoading: false,
    webhookList: action.payload?.data || [],
  };
case GET_WEBHOOKS_FAIL:
  return {
    ...state,
    webhookLoading: false,
    webhookList: [],
  };

// Update Webhook
case UPDATE_WEBHOOK_REQUEST:
  return {
    ...state,
    webhookLoading: true,
  };
case UPDATE_WEBHOOK_SUCCESS:
  return {
    ...state,
    webhookLoading: false,
  };
case UPDATE_WEBHOOK_FAIL:
  return {
    ...state,
    webhookLoading: false,
  };

// Delete Webhook
case DELETE_WEBHOOK_REQUEST:
  return {
    ...state,
    webhookLoading: true,
  };
case DELETE_WEBHOOK_SUCCESS:
  return {
    ...state,
    webhookLoading: false,
  };
case DELETE_WEBHOOK_FAIL:
  return {
    ...state,
    webhookLoading: false,
  };

// Get Webhook Events
case GET_WEBHOOK_EVENTS_REQUEST:
  return {
    ...state,
    webhookLoading: true,
    webhookEvents: [],
  };
 case GET_WEBHOOK_EVENTS_SUCCESS:
      return {
        ...state,
        webhookLoading: false,
        webhookEvents: Object.values(action.payload?.data || {}), // convert object to array
      }

case GET_WEBHOOK_EVENTS_FAIL:
  return {
    ...state,
    webhookLoading: false,
    webhookEvents: [],
  };

case GET_ACTIVE_WEBHOOKS_REQUEST:
  return {
    ...state,
    activeWebhookLoading: true,
    webhookActiveList: [],
  };
case GET_ACTIVE_WEBHOOKS_SUCCESS:
  return {
    ...state,
    activeWebhookLoading: false,
    webhookActiveList: action.payload?.data || [],
  };
case GET_ACTIVE_WEBHOOKS_FAIL:
  return {
    ...state,
    activeWebhookLoading: false,
    webhookActiveList: [],
  };

// Privacy Policy
case GET_PRIVACY_POLICY_REQUEST:
  return {
    ...state,
    privacyPolicyLoading: true,
    privacyPolicy: null,
  };
case GET_PRIVACY_POLICY_SUCCESS:
  return {
    ...state,
    privacyPolicyLoading: false,
    privacyPolicy: action.payload?.data || null,
  };
case GET_PRIVACY_POLICY_FAIL:
  return {
    ...state,
    privacyPolicyLoading: false,
    privacyPolicy: null,
  };

case SAVE_PRIVACY_POLICY_REQUEST:
  return {
    ...state,
    privacyPolicyLoading: true,
  };
case SAVE_PRIVACY_POLICY_SUCCESS:
  return {
    ...state,
    privacyPolicyLoading: false,
  };
case SAVE_PRIVACY_POLICY_FAIL:
  return {
    ...state,
    privacyPolicyLoading: false,
  };

// Cookie Policy
case GET_COOKIE_POLICY_REQUEST:
  return {
    ...state,
    cookiePolicyLoading: true,
    cookiePolicy: null,
  };
case GET_COOKIE_POLICY_SUCCESS:
  return {
    ...state,
    cookiePolicyLoading: false,
    cookiePolicy: action.payload?.data || null,
  };
case GET_COOKIE_POLICY_FAIL:
  return {
    ...state,
    cookiePolicyLoading: false,
    cookiePolicy: null,
  };

case SAVE_COOKIE_POLICY_REQUEST:
  return {
    ...state,
    cookiePolicyLoading: true,
  };
case SAVE_COOKIE_POLICY_SUCCESS:
  return {
    ...state,
    cookiePolicyLoading: false,
  };
case SAVE_COOKIE_POLICY_FAIL:
  return {
    ...state,
    cookiePolicyLoading: false,
  };

case TOGGLE_COOKIE_POLICY_REQUEST:
  return {
    ...state,
    cookiePolicyLoading: true,
  };
case TOGGLE_COOKIE_POLICY_SUCCESS:
  return {
    ...state,
    cookiePolicyLoading: false,
    cookiePolicy: state.cookiePolicy ? { ...state.cookiePolicy, is_enabled: action.payload?.is_enabled ? 1 : 0 } : { is_enabled: action.payload?.is_enabled ? 1 : 0 },
  };
case TOGGLE_COOKIE_POLICY_FAIL:
  return {
    ...state,
    cookiePolicyLoading: false,
  };


    default:
      return state;
  }
}

export { surveyReducer }